import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import { freelancerInfoPanelClicked } from '../../actions/clientFreelancerData';
import {
    DispatchProps,
    FreelancerInfoPanel,
    OwnProps,
    StateProps
} from '../../components/FreelancerInfoPanel/FreelancerInfoPanel';
import { State } from '../../typings/state';

export const mapStateToProps = (state: State): StateProps => {
    const {
        commonData: { authorizationData, login, clientFreelancerData, isClientFreelancerDataLoading }
    } = state;

    return {
        clientFreelancerData,
        isClientFreelancerDataLoading,
        authorizationData,
        ulogin: login
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>): DispatchProps => {
    return {
        onInfoPanelClicked: clickType => dispatch(freelancerInfoPanelClicked(clickType))
    };
};

export const FreelancerInfoPanelContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(FreelancerInfoPanel);
